import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routes";

import { ThemeProvider } from "styled-components";
import themes from "./config/themes";

import "antd/dist/antd.css";
import "./antd_overrides.css";
import "./index.css";
import "./layout.css";

import { Provider } from "react-redux";
import { store } from "./redux/store";

ReactDOM.render(
  <ThemeProvider theme={themes["themedefault"]}>
    <Provider store={store}>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </Provider>
  </ThemeProvider>,
  document.getElementById("root")
);
